import { render, staticRenderFns } from "./ProposalAnalysis.vue?vue&type=template&id=39aa4afe&"
import script from "./ProposalAnalysis.vue?vue&type=script&lang=js&"
export * from "./ProposalAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports